exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card.custom-border-width[data-v-fc817972]{border-width:2px!important}", ""]);

// exports
